module.exports = __webpack_public_path__ + "b95c3648109eeee02accd433b44096b0.pdf";